import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Container, Box, CircularProgress, Typography } from '@mui/material';

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasHandled = useRef(false); // ✅ Sadece bir kez çalışsın

  useEffect(() => {
    if (hasHandled.current) return;
    hasHandled.current = true;

    const params = new URLSearchParams(location.search);
    const token = params.get('token');
    const userDataStr = params.get('userData');

    if (token && userDataStr) {
      try {
        const userData = JSON.parse(decodeURIComponent(userDataStr));
        localStorage.setItem('authToken', token);
        localStorage.setItem('userData', JSON.stringify(userData));
        console.log(localStorage);
        toast.success('Başarıyla giriş yapıldı!');

        // ✅ navigate çağrısını zamanlayarak tetikle
        setTimeout(() => {
          window.location.replace('/dashboard');
        }, 1000);

      } catch (error) {
        console.error('Callback hatası:', error);
        toast.error('Giriş işlemi tamamlanamadı.');
        setTimeout(() => {
          window.location.replace('/');
        }, 1000);
      }
    } else {
      toast.error('Geçersiz token ya da kullanıcı bilgisi.');
      setTimeout(() => {
        window.location.replace('/');
      }, 1000);
    }
  }, [location.search, navigate]);

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <CircularProgress />
        <Typography sx={{ mt: 2 }}>Giriş yapılıyor...</Typography>
      </Box>
    </Container>
  );
};

export default AuthCallback;
